import React from 'react';
import { useMainSMSVerificationPresenter } from './MainSMSVerification.presenter';

import { ProcessInfoState } from './components/ProcessInfoState/ProcessInfoState';

import { secondsToTimerString } from 'utils/common';
import { VOID_FUNCTION } from 'constants/index';

import * as S from './MainSMSVerification.styles';

export const MainSMSVerification = ({
  appId,
  dealerId,
  customer,
  onClick = VOID_FUNCTION,
  onClose = VOID_FUNCTION,
  onSuccess = VOID_FUNCTION,
}) => {
  const presenter = useMainSMSVerificationPresenter({
    appId,
    dealerId,
    customer,
    onClick,
    onSuccess,
  });

  return (
    <S.StyledPopup onClose={onClose}>
      <S.Title>
        Отправили СМС с кодом на номер
        <br />
        {customer?.contacts?.mobilePhone || ''}
      </S.Title>
      <S.Container>
        <S.Description>
          <S.DescriptionText>
            Чтобы подписать согласие, клиенту нужно отправить код ответным СМС.
            <br />
            Это бесплатно. Код можно отправить до 3 раз
          </S.DescriptionText>
        </S.Description>

        {presenter.statusMap.map(
          ({ condition, props }) => condition && <ProcessInfoState key={props.id} {...props} />
        )}

        {presenter.isViewTimeoutButton ? (
          <S.TimeOutButton onClick={presenter.noSMSClickHandler}>
            Отправить код для подписания
          </S.TimeOutButton>
        ) : presenter.isViewTryoutButton ? (
          <S.TryOutButton onClick={presenter.noSMSClickHandler}>
            Клиенту не приходит сообщение
          </S.TryOutButton>
        ) : (
          <S.SendButton
            disabled={!presenter.isViewResendButton || presenter.hasNoSMS}
            subTitle={presenter.getSubTitle}
            onClick={presenter.resendCodeHandler}
          >
            {!presenter.isViewResendButton
              ? `Отправить повторно через ${secondsToTimerString(presenter.timer.seconds)}`
              : 'Отправить код ещё раз'}
          </S.SendButton>
        )}
      </S.Container>
    </S.StyledPopup>
  );
};
